import { render, staticRenderFns } from "./studio.vue?vue&type=template&id=46932ed6&"
import script from "./studio.vue?vue&type=script&lang=js&"
export * from "./studio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports